var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.90532 3.23642H28.0958C28.7533 3.23642 29.2863 2.70343 29.2863 2.04595C29.2863 1.38846 28.7533 0.855469 28.0958 0.855469H1.90532C1.24784 0.855469 0.714844 1.38846 0.714844 2.04595C0.714844 2.70343 1.24784 3.23642 1.90532 3.23642ZM1.90532 9.1888H28.0958C28.7533 9.1888 29.2863 8.65581 29.2863 7.99833C29.2863 7.34084 28.7533 6.80785 28.0958 6.80785H1.90532C1.24784 6.80785 0.714844 7.34084 0.714844 7.99833C0.714844 8.65581 1.24784 9.1888 1.90532 9.1888ZM28.0958 15.1412H1.90532C1.24784 15.1412 0.714844 14.6082 0.714844 13.9507C0.714844 13.2932 1.24784 12.7602 1.90532 12.7602H28.0958C28.7533 12.7602 29.2863 13.2932 29.2863 13.9507C29.2863 14.6082 28.7533 15.1412 28.0958 15.1412Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.d84946c0e57b3b05f2b60dfa8c58774c.svg";
export { ForwardRef as ReactComponent };